import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConcurrenceService {

  constructor(private _httpClient: HttpClient) { }
  closeConcurrence(branchId: number, concurrenceCode: number): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.concurrence.CloseConcurrence}/${branchId}/${concurrenceCode}`,
      null);
  }
}
